import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { certificateModalQueriesKeys } from '../constants'
import { useMtlsCertificateStore } from '../../../zustand/mtls-certificate/use-mtls-certificate-store.jsx'

/**
 * Fetches a client key for BIG Project.
 * @param {Object} options - Additional options for the query.
 * @returns {Object} - Downloads the cert key
 */

export const useCheckCertificateQuery = (options) => {
  const handleQuery = async () => {
    const config = {
      method: 'GET'
    }

    const response = await api(`/api/v2/me/objectstore`, config)

    if (response.status === 204) {
      return null
    }

    const { mtls } = response.data
    const state = useMtlsCertificateStore.getState()

    state.setMtlsEnabled(mtls)

    if (mtls) {
      const response = await api('/api/v2/object-store/mtls/check-url', config)
      const endpoint = response.data
      state.setEndpoint(endpoint)

      return await api(endpoint, { ...config, skipHeaders: true })
    }

    return null
  }

  return useQuery({
    queryKey: [certificateModalQueriesKeys.CHECK_CERTIFICATE],
    queryFn: handleQuery,
    retry: 0,
    ...options
  })
}
